module.exports = __webpack_public_path__ + "img/program-stage.cb80a23e.png";